ixModuleRouting("impactx.vendor", {
    "/vendorlist": {
        template: "<ixa-vendor-list></ixa-vendor-list>",
        process: "VENDOR",
        workspace: "admin",
    },
    "/vendor/:id": {
        template: "<ixa-vendor-dialog></ixa-vendor-dialog>",
        templateUrl: "modules/vendor/templates/vendor.html",
        process: "VENDOR",
        controller: "VendorCtrl",
        controllerAs: "vendorCtrl",
        workspace: "admin",
    },
});
